module.exports = "/_next/static/images/paint-bucket-69118974c4a95ba84610fa51453d5113.svg";